import { fetchApiData } from "client/utils/fetchApiData";
import getQueryString from "client/utils/getQueryString";
import { PartnerSearchResponse } from "../../../../types";

export default (search?: string): Promise<PartnerSearchResponse> => {
  return fetchApiData({
    url: `/api/user/partners/${search ? getQueryString({ search: search ?? "" }) : ""}`,
  });
};
